import React from 'react';
import Recipient from '../../utils/tabs/recipient/Recipient';

/**
 * Affiche le composant d'information sur le destinataire du colis dans le drawer
 * de la section colis prêt
 */
const RecipientTab = () => (
  <div>
    <Recipient />
  </div>
);

export default RecipientTab;
